<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img id="profile-img" src="../assets/ggpoker.png" />
      <Form @submit="handleSendBalance" :validation-schema="schema">
        <div>
          <div class="form-group">
            <label for="user">Usuário</label>
            <Field name="user" as="select" class="form-control" v-model="fields.user">
              <option value="">Selecione o usuário</option>
              <option v-for="i in userOptions" :value="i.value" :key="i.value">
                {{ i.text }}
              </option>
            </Field>
            <ErrorMessage name="user" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="type">Tipo</label>
            <!-- <Field name="typePix" type="text" class="form-control" /> -->
            <Field name="type" as="select" class="form-control" v-model="fields.type">
              <option value="Add">Adicionar</option>
              <option value="Sub">Subtrair</option>
            </Field>
            <ErrorMessage name="type" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="value">Valor</label>
            <Field name="value" type="number" class="form-control" v-model="fields.value"/>
            <ErrorMessage name="value" class="error-feedback" />
          </div>

          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              Enviar
            </button>
          </div>
        </div>
      </Form>

      <div
        v-if="message"
        class="alert"
        :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>
  
  <script>
import UserService from "../services/user.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "SendBalance",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      // username: yup
      //   .string()
      //   .required("Username is required!")
      //   .min(3, "Must be at least 3 characters!")
      //   .max(20, "Must be maximum 20 characters!"),
      // email: yup
      //   .string()
      //   .required("Email is required!")
      //   .email("Email is invalid!")
      //   .max(50, "Must be maximum 50 characters!"),
      // password: yup
      //   .string()
      //   .required("Password is required!")
      //   .min(6, "Must be at least 6 characters!")
      //   .max(40, "Must be maximum 40 characters!"),
    });

    return {
      successful: false,
      loading: false,
      message: "",
      schema,
      fields:{
        user:"",
        type:"",
        value:"",
      },
      userOptions: [],
    };
  },
  computed: {
    loggedIn() {
      return (this.$store.state.auth.status.loggedIn && this.$store.state.auth.user.validOTP);
    },
  },
  mounted() {
    if (!this.loggedIn) {
      this.$root.logOut();
    }
    if (this.loggedIn) {
      UserService.getListUser().then(
        (response) => {
          if (response.data.result) {
            this.userOptions = response.data.data;
          }
        },
        (error) => {
          this.userOptions = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  },
  methods: {
    handleSendBalance(data) {
      this.message = "";
      this.successful = false;
      this.loading = true;
      this.$store.dispatch("balance/sendBalance", data).then(
        (data) => {
          this.fields.user = '';
          this.fields.type = '';
          this.fields.value = '';
          this.message = data.message;
          this.successful = true;
          this.loading = false;
          setTimeout(() => {
            this.message = "";
            this.successful = false;
            this.loading = false;
          }, 3000);
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>
  
  <style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
  